import { createApp } from 'vue'; // Import createApp instead of Vue
import FlyoverPreview from './FlyoverPreview.vue';

// Find the target element first
const targetElement = document.querySelector('#flyover_preview');

// Check if the element exists before trying to mount
if (targetElement) {
  // Create the Vue 3 app instance, passing the root component directly
  const app = createApp(FlyoverPreview);

  // Mount the app instance to the target element
  // Note: .mount() in Vue 3 returns the root component instance,
  // not the app instance itself, unlike Vue 2's $mount.
  app.mount(targetElement); // You can pass the selector string or the element itself
}
